var React = require('react');

function Programming (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M93.918 45.833L69.799 21.714c-.75-.75-2.077-.75-2.827 0l-5.229 5.229a2 2 0 0 0 0 2.828L79.22 47.246 61.744 64.724a2 2 0 0 0 0 2.828l5.229 5.229c.375.375.884.587 1.414.587.529 0 1.039-.212 1.414-.587l24.117-24.118a2.002 2.002 0 0 0 0-2.83zM32.759 64.724L15.285 47.248l17.477-17.475a1.999 1.999 0 0 0 0-2.828l-5.229-5.229a2 2 0 0 0-2.828 0L.585 45.833a2 2 0 0 0 0 2.829L24.704 72.78c.375.375.884.587 1.414.587.53 0 1.039-.212 1.414-.587l5.229-5.229a1.997 1.997 0 0 0-.002-2.827zM60.967 13.6a2.001 2.001 0 0 0-1.19-.962l-4.239-1.251a2 2 0 0 0-2.484 1.352L33.375 79.382a2 2 0 0 0 1.351 2.484l4.239 1.251a1.996 1.996 0 0 0 2.484-1.352l19.679-66.644a1.995 1.995 0 0 0-.161-1.521z"}));
}

Programming.defaultProps = {"width":"94.504","height":"94.504","viewBox":"0 0 94.504 94.504"};

module.exports = Programming;

Programming.default = Programming;
